/* global $, jQuery */
//
// Fake Loader
// Usage :
// Automatique : au changement de page
// Forcé : sur des requète AJAX
//    onclick="window.FakeLoader.showOverlay(500)"
//    onclick="window.FakeLoader.hideOverlay(500)"
//
window.FakeLoader = (function ($, window, document) {
    const settings = {
        auto_hide: true,
        overlay_id: 'fakeloader-overlay',
        fade_timeout: 200,
        wait_for_images: true,
        wait_for_images_selector: 'body',
    };

    let $overlay = null;

    const fakeLoader = {

        hideOverlay(timeout = null) {
            $overlay.removeClass('visible');

            window.setTimeout(
                () => {
                    $overlay.addClass('hidden');
                },
                timeout || settings.fade_timeout,
            );
        },

        showOverlay() {
            $overlay.removeClass('hidden').addClass('visible');
        },

        init(givenSettings) {
            $.extend(settings, givenSettings);

            if ($(`#${settings.overlay_id}`).length <= 0) {
                $overlay = $(`<div id="${settings.overlay_id}" class="visible incoming"><div class="loader-wrapper-outer"><div class="loader-wrapper-inner"><div class="loader"></div></div></div></div>`);
                $('body').append($overlay);

                if (typeof (console) !== 'undefined' && typeof (console.log) !== 'undefined') {
                    console.log('You should put the fakeLoader loading overlay element in your markup directly for best results.');
                }
            } else {
                $overlay = $(`#${settings.overlay_id}`);
            }

            $overlay.click(
                () => {
                    fakeLoader.hideOverlay();
                },
            );

            $(window).bind('beforeunload', () => {
                $(`#${settings.overlay_id}`).removeClass('incoming').addClass('outgoing');
                fakeLoader.showOverlay();
            });

            $(document).ready(
                () => {
                    if (settings.auto_hide === true) {
                        if (typeof ($.fn.waitForImages) === 'function' && settings.wait_for_images === true) {
                            $(settings.wait_for_images_selector).waitForImages(
                                () => {
                                    fakeLoader.hideOverlay();
                                },
                            );
                        } else {
                            fakeLoader.hideOverlay();
                        }
                    }
                },
            );
        },

    };

    return fakeLoader;
}(jQuery, window, document));

$(document).ready(
    () => {
        window.FakeLoader.init({ auto_hide: true });
    },
);
